module.exports = __webpack_public_path__ + "static/media/appstore@2x.1b97c6f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/appstore@2x.png
// module id = 743
// module chunks = 0